import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CreateNotification,
  DeleteNotification,
  DraftToSubmit,
  GetAllNotification_M1,
  GetAllNotification_M3,
  GetNotificationByID,
  GetPulishedNotification,
  IAPIState,
  PublishNotification,
  RecallNotification,
  UpdateAssignToNotification,
  UpdateNotification,
} from "../api/notifyapi/Notifyapi";
import dayjs from "dayjs";
import {
  getApiFailState,
  getApiInitState,
  getApiLoadingState,
  getApiSuccessState,
} from "../api/notifyapi/APIShared";

import NotificationTableActionHandler from "../components/Mangement/notificationPage/NotificationTableActionHandler";
import { INotificationFeatures, ISSOUser } from "./UserSlice";

import NotificationCheckboxHandlerNew from "../components/Mangement/notificationPage/NotificationCheckboxHandler";
import { getinitNotificationFeatures } from "./helper/UserSliceHelper";

import { ESearchFilterActiveTypes } from "../constants/CommonInterfaces";
import { DBTilte } from "../components/Mangement/modal/CloumnFilter/ExtensiveFilterContent";

export interface IFilterResponse {
  data: IUINotification_View_3[];
  page: number;
  pageSize: number;
  totalCount: number;
  sortBy: string;
}
export interface IPrepareIndividualData {
  nUniqueID: string;
  notificationID: string;
  title: string;
  description: string;
  target: any;
  expiryDate: string;
  effectiveDate: string;
  category: string;
  level: string;
  attachments: {
    fileName: string;
    copiedPath: string;
    uploadTime: string;
  }[];
  createdBy: { name: string; dateTime: string };
  updatedBy: { name: string; dateTime: string };
  assignedUser: string[];
  status: string;
  zipFile: string;
  publishedOn: string;
  publishStatus: string;
  publishedBy: string;
}

export interface IVisibility {
  visibility: boolean;
}
export interface IFile {
  fileName: string;
  copiedPath: string;
  uploadTime: string;
}
export interface INotificationTableList {
  nUniqueID: string;
  notificationID: string;
  title: string;
  description: string;
  target: any;
  expiryDate: string;
  effectiveDate: string;
  category: string;
  level: string;
  attachments: IFile[];
  createdBy: { name: string; dateTime: string };
  updatedBy: { name: string; dateTime: string };
  assignedUser: string[];
  status: string;
  assignedOn: string;
  publishedBy: string;
  publishedOn: string;
  publishStatus: string;
  zipFile: string;
  actions: INotificationTableActions;
  rowSelection: IVisibility;
}

export interface IMultiAssignData {
  selectionType: "assigned" | "reassign" | "none";
  assignedUser: string;
  level: string;
}

export interface INotificationTableActions {
  view: ITableRowActionField;
  edit: ITableRowActionField;
  assign: ITableRowActionField;
  recall: ITableRowActionField;
  delete: ITableRowActionField;
}

export interface ITableRowActionField {
  applicable: ETableRowActionFieldApplicable;
  message: string;
}

export enum ETableRowActionFieldApplicable {
  Show,
  Blur,
  Hide,
}

export interface IFilter {
  field: string;
  operator: string;
  value: string;
}

export interface IFilterModel {
  filters: IFilter[];
  isAscending: boolean;
  isOr: boolean;
  page: number;
  pageSize: number;
  currentPageSize: number;
  sortField: string;
  isPageChanged: string;
}

export interface IGlobalSearchFilterModel {
  filters: IFilter[];
  isOr: boolean;
}

export interface IUINotification_View_2 {
  NotificationID: string;
  Title: string;
  Category: string;
  CreatedBy: string;
  CreatedOn: string;
  UpdatedBy: string;
  UpdatedOn: string;
  Level: string;
  Status: string;
  AssignedUser: string[];
}
export interface IUINotification_View_3 {
  nUniqueID: string;
  notificationID: string;
  attachments: IFile[];
  title: string;
  description: string;
  target: any;
  expiryDate: string;
  effectiveDate: string;
  category: string;
  createdBy: string;
  createdOn: string;
  updatedBy: string;
  updatedOn: string;
  level: string;
  status: string;
  assignedUser: string[];
  assignedOn: string;
  publishedBy: string;
  publishedOn: string;
  publishStatus: string;
  zipFile: string;
  rowSelection: { visibility: boolean };
}
export interface ITableData extends IUINotification_View_3 {
  Action: INotificationAction;
}
export interface INotificationAction {
  View: IActions;
  Assign: IActions;
  Recall: IActions;
  Edit: IActions;
  Delete: IActions;
  Publish: IActions;
  Submit: IActions;
}
export interface IActions {
  IsApplicable: boolean;
  Message: string;
}
export interface ILocalFilterValue {
  NUniqueID: IColumFilter;
  title: IColumFilter;
  createdBy: IColumFilter;
  updatedBy: IColumFilter;
  status: IColumFilter;
  category: IColumFilter;
  createdOn: IColumFilter;
  updatedOn: IColumFilter;
}

export const columnSearch: ILocalFilterValue = {
  NUniqueID: {
    value: "",
    isFiltered: false,
    sort: "none",
  },
  title: {
    value: "",
    isFiltered: false,
    sort: "none",
  },
  createdBy: {
    value: "",
    isFiltered: false,
    sort: "none",
  },
  updatedBy: {
    value: "",
    isFiltered: false,
    sort: "none",
  },
  status: {
    value: "",
    isFiltered: false,
    sort: "none",
  },
  category: {
    value: "",
    isFiltered: false,
    sort: "none",
  },
  createdOn: {
    value: "",
    isFiltered: false,
    sort: "none",
  },
  updatedOn: {
    value: "",
    isFiltered: false,
    sort: "none",
  },
};

interface IColumFilter {
  value: any;
  isFiltered: boolean;
  sort: "ascending" | "descending" | "none";
}

interface INotificationSlice {
  enableAssign: boolean;
  enableRecall: boolean;
  GlobalLevel: string;
  SetEditAndDeleteId: string;
  HandleDeletePopup: boolean;
  HandleViewPopup: boolean;
  IsActionPopupVisible: boolean;
  IsAssigned: boolean;
  api: IAPIState;
  PublishedNotifications: IUINotification_View_3[];
  tableData: INotificationTableList[];
  notification_M2: IUINotification_View_2[];
  notification_M3: IUINotification_View_3[];
  notification_M1: any;
  notificationFeatures: INotificationFeatures;
  user: ISSOUser | null;
  activeRole: string;
  editData: IPrepareIndividualData | null;
  totalCount: number;
  selectedRowData: { [key: string]: INotificationTableList };
  MultipleAssign: IMultiAssignData;
  searchFilter: {
    globalSearch: {
      value: string;
      isActive: boolean;
    };
    columnSearch: ILocalFilterValue;
    tempColumnSearch: ILocalFilterValue;
    apiQuery: IFilterModel;
    globalSearchApiQuery: IGlobalSearchFilterModel;
    lastActiveSearch: ESearchFilterActiveTypes;
  };
}

const notificationInitalState: INotificationSlice = {
  PublishedNotifications: [],
  api: getApiInitState(),
  enableAssign: false,
  enableRecall: false,
  GlobalLevel: "ALL",
  HandleViewPopup: false,
  HandleDeletePopup: false,
  IsActionPopupVisible: false,
  IsAssigned: false,
  tableData: [],
  notification_M1: [],
  notification_M2: [],
  notification_M3: [],
  notificationFeatures: getinitNotificationFeatures(),
  user: null,
  activeRole: "",
  editData: null,
  SetEditAndDeleteId: "",
  searchFilter: {
    globalSearch: {
      value: "",
      isActive: false,
    },
    globalSearchApiQuery: {
      filters: [],
      isOr: false,
    },
    columnSearch: columnSearch,
    tempColumnSearch: columnSearch,
    apiQuery: {
      filters: [],
      isAscending: false,
      isOr: false,
      page: 1,
      pageSize: 10,
      currentPageSize: 0,
      sortField: "",
      isPageChanged: "",
    },
    lastActiveSearch: ESearchFilterActiveTypes.none,
  },
  totalCount: 0,
  selectedRowData: {},
  MultipleAssign: {
    assignedUser: "",
    selectionType: "none",
    level: "",
  },
};

const notificationSlice = createSlice({
  name: "Notification",
  initialState: notificationInitalState,
  reducers: {
    updateIsAssigned: (state, action: PayloadAction<boolean>) => {
      state.IsAssigned = action.payload;
    },
    UpdateUser: (state, action: PayloadAction<ISSOUser | null>) => {
      state.user = action.payload;
    },
    UpdateRole: (state, action: PayloadAction<string>) => {
      state.activeRole = action.payload;
    },
    UpdateNotificationFeatures: (
      state,
      action: PayloadAction<INotificationFeatures>
    ) => {
      state.notificationFeatures = action.payload;
      NotificationCheckboxHandlerNew(
        state.tableData,
        state.user,
        state.MultipleAssign,
        state.notificationFeatures
      );
      NotificationTableActionHandler(
        state.tableData,
        state.user,
        state.notificationFeatures
      );
    },
    UpdateVisible: (state, action: PayloadAction<boolean>) => {
      state.IsActionPopupVisible = action.payload;
    },
    UpdateDeletePopup: (state, action: PayloadAction<boolean>) => {
      state.HandleDeletePopup = action.payload;
    },
    UpdateViewPopup: (state, action: PayloadAction<boolean>) => {
      state.HandleViewPopup = action.payload;
    },
    UpdateId: (state, action: PayloadAction<string>) => {
      state.SetEditAndDeleteId = action.payload;
    },
    UpdateSetGlobalLevel: (state, action: PayloadAction<string>) => {
      state.GlobalLevel = action.payload;
    },
    GetDataById: (state, action: PayloadAction<{ id: string }>) => {
      state.editData = prepareIndividualData(
        action.payload.id,
        state.tableData
      );
    },
    UpdateRecallAction: (state, action: PayloadAction<boolean>) => {
      state.enableRecall = action.payload;
    },
    UpdateEnableAssign: (state, action: PayloadAction<boolean>) => {
      state.enableAssign = action.payload;
    },
    ApplyColumnSearchFilter: (state) => {
      // Copy columnSearch to tempColumnSearch
      state.searchFilter.tempColumnSearch = Object.assign(
        {},
        state.searchFilter.columnSearch
      );
      // Clear existing filters for the applied columns
      const fieldsToCheck: (keyof typeof DBTilte)[] = [
        "NUniqueID",
        "title",
        "createdBy",
        "updatedBy",
        "category",
        "status",
        "createdOn",
        "updatedOn",
      ];

      // Remove existing filters for the columns being filtered
      state.searchFilter.apiQuery.filters =
        state.searchFilter.apiQuery.filters.filter(
          (filter) =>
            !fieldsToCheck.some((field) => filter.field === DBTilte[field])
        );

      // Add new filters based on tempColumnSearch
      fieldsToCheck.forEach((field) => {
        const localField =
          state.searchFilter.tempColumnSearch[field as keyof ILocalFilterValue];
        if (localField.value) {
          let operator = "contains";
          let value = localField.value;

          if (field === "createdOn" || field === "updatedOn") {
            operator = "date";
            const dates = localField.value;
            const startDate = dates[0];
            const endDate = dates[1];
            if (startDate !== "" && endDate !== "") {
              const formatDate1 = dayjs(startDate).format("YYYYMMDDHHmmss");
              const formatDate2 = dayjs(endDate).format("YYYYMMDDHHmmss");
              value = `${formatDate1}:${formatDate2}`;
            }
          }

          state.searchFilter.apiQuery.filters.push({
            field: DBTilte[field],
            operator: operator,
            value: value,
          });
        }
      });
    },
    UpdateLocalSearchQuery: (
      state,
      action: PayloadAction<{ field: string; value: any }>
    ) => {
      let t: keyof ILocalFilterValue;

      for (t in state.searchFilter.columnSearch) {
        if (t === action.payload.field) {
          state.searchFilter.columnSearch[t].value = action.payload.value;

          if (state.searchFilter.columnSearch[t].value?.length > 0) {
            state.searchFilter.columnSearch[t].isFiltered = true;
          } else {
            state.searchFilter.columnSearch[t].isFiltered = false;
          }
        }
      }

      //state.searchQueryLocal[action.payload.field].value = action.payload.value
    },
    UpdateSearchQuery: (state, action: PayloadAction<IFilter>) => {
      // Trim the value to check for empty strings
      const trimmedValue =
        typeof action.payload.value === "string"
          ? action.payload.value.trim()
          : action.payload.value;

      // Skip adding filter for empty values
      const isEmptyValue =
        trimmedValue === "" ||
        trimmedValue === null ||
        trimmedValue === undefined;

      if (isEmptyValue) {
        // If the value is empty, remove any existing filter for this field
        state.searchFilter.apiQuery.filters =
          state.searchFilter.apiQuery.filters.filter(
            (item) => item.field !== action.payload.field
          );
        return;
      }

      const existingFilterIndex = state.searchFilter.apiQuery.filters.findIndex(
        (item: IFilter) => item.field === action.payload.field
      );

      if (action.payload.value === "ALL") {
        // If the value is "ALL", remove the filter for that field
        state.searchFilter.apiQuery.filters =
          state.searchFilter.apiQuery.filters.filter(
            (item) => item.field !== action.payload.field
          );
      } else {
        if (existingFilterIndex !== -1) {
          // Update the existing filter's value
          state.searchFilter.apiQuery.filters[existingFilterIndex].value =
            trimmedValue;
        } else {
          // Add the new filter to the list
          state.searchFilter.apiQuery.filters.push({
            ...action.payload,
            value: trimmedValue,
          });
        }
      }
    },
    UpdateSorting: (
      state,
      action: PayloadAction<{ sortField: string; isAscending: boolean }>
    ) => {
      state.searchFilter.apiQuery.isAscending = action.payload.isAscending;
      state.searchFilter.apiQuery.sortField = action.payload.sortField;
      state.searchFilter.apiQuery.page = 1;
    },
    UpdatePagination: (
      state,
      action: PayloadAction<{
        page: number;
        pageSize: number;
        isPageChanged: boolean;
      }>
    ) => {
      state.searchFilter.apiQuery.page = action.payload.page;
      state.searchFilter.apiQuery.pageSize = action.payload.pageSize;

      if (action.payload.isPageChanged) {
        state.searchFilter.apiQuery.isPageChanged = new Date().toTimeString();
      }
    },
    UpdateSelectedRowData: (
      state,
      action: PayloadAction<{ [key: string]: INotificationTableList }>
    ) => {
      state.selectedRowData = action.payload;
    },
    UpdateMultipleAssign: (
      state,
      action: PayloadAction<{ [key: string]: INotificationTableList }>
    ) => {
      const selectedRows = action.payload;
      const rowKeys = Object.keys(selectedRows);

      if (rowKeys.length === 0) {
        state.MultipleAssign = {
          assignedUser: "",
          selectionType: "none",
          level: "",
        };
        //Defining the row selection visibility
        NotificationCheckboxHandlerNew(
          state.tableData,
          state.user,
          state.MultipleAssign,
          state.notificationFeatures
        );
        return;
      } else if (rowKeys.length === 1) {
        const firstRow = selectedRows[rowKeys[0]];

        state.MultipleAssign = {
          assignedUser:
            firstRow.assignedUser.length > 0 ? firstRow.assignedUser[0] : "",
          selectionType:
            firstRow.assignedUser.length > 0 ? "reassign" : "assigned",
          level: firstRow.level,
        };
        //Defining the row selection visibility
        NotificationCheckboxHandlerNew(
          state.tableData,
          state.user,
          state.MultipleAssign,
          state.notificationFeatures
        );
        return;
      }
      return;
    },
    UpdateGlobalSearchFilter: (
      state,
      action: PayloadAction<{
        value: string;
      }>
    ) => {
      // Here set Global search set For UI purpose
      state.searchFilter.globalSearch.value = action.payload.value;
    },
    UpdateGlobalSearchApiQuery: (
      state,
      action: PayloadAction<{
        value: string;
        needToSetActive: boolean | undefined;
        level?: string;
      }>
    ) => {
      // Here Sent the Global value into api query for backend
      if (action.payload.value.length > 0) {
        state.searchFilter.globalSearchApiQuery.filters = [
          {
            field: "GeneralDetails.Level",
            operator: "eq",
            value:
              action.payload.level && action.payload.level !== ""
                ? action.payload.level
                : "ALL",
          },
          {
            field: DBTilte.NUniqueID,
            operator: "contains",
            value: action.payload.value,
          },
          {
            field: DBTilte.title,
            operator: "contains",
            value: action.payload.value,
          },
          // {
          //   field: DBTilte.category,
          //   operator: "contains",
          //   value: action.payload.value,
          // },
          // {
          //   field: DBTilte.status,
          //   operator: "contains",
          //   value: action.payload.value,
          // },
          {
            field: DBTilte.createdBy,
            operator: "contains",
            value: action.payload.value,
          },
          {
            field: DBTilte.updatedBy,
            operator: "contains",
            value: action.payload.value,
          },
        ];
        state.searchFilter.globalSearchApiQuery.isOr = true;
      } else {
        state.searchFilter.globalSearchApiQuery.filters = [
          {
            field: "GeneralDetails.Level",
            operator: "eq",
            value: action.payload.level ? action.payload.level : "ALL",
          },
        ];
        state.searchFilter.globalSearchApiQuery.isOr = false;

        if (
          state.searchFilter.globalSearchApiQuery.filters.length > 0 &&
          state.searchFilter.globalSearchApiQuery.filters[0].field ===
            DBTilte.level
        ) {
          state.searchFilter.globalSearchApiQuery.filters[0].value =
            state.GlobalLevel;
        }
      }

      if (action.payload.needToSetActive) {
        if (state.searchFilter.globalSearch.value?.length > 0) {
          state.searchFilter.globalSearch.isActive = true;
        } else {
          state.searchFilter.globalSearch.isActive = false;
        }
      }
    },
    UpdateGlobalSearchFilterActive: (state) => {
      state.searchFilter.apiQuery.page = 1;
      if (state.searchFilter.globalSearch.value?.length > 0) {
        state.searchFilter.globalSearch.isActive = true;
      } else {
        state.searchFilter.globalSearch.isActive = false;
      }
    },
    UpdateLastActiveSearch: (
      state,
      action: PayloadAction<{ value: ESearchFilterActiveTypes }>
    ) => {
      state.searchFilter.lastActiveSearch = action.payload.value;
    },
    resetLocalSearchQuery: (
      state,
      action: PayloadAction<{
        canClearAll: boolean;
        fieldClear: string;
        field2?: string;
      }>
    ) => {
      if (action.payload.canClearAll) {
        // Reset everything as before
        state.searchFilter.columnSearch =
          notificationInitalState.searchFilter.columnSearch;
        state.searchFilter.apiQuery.filters =
          notificationInitalState.searchFilter.apiQuery.filters;
      } else if (action.payload.fieldClear?.length > 0) {
        // Clear column search value and isFiltered
        let t: keyof ILocalFilterValue;
        for (t in state.searchFilter.columnSearch) {
          if (t === action.payload.fieldClear) {
            state.searchFilter.columnSearch[t].value = "";
            state.searchFilter.columnSearch[t].isFiltered = false;

            // Remove corresponding filter from apiQuery filtersusing DBTilte mapping
            state.searchFilter.apiQuery.filters =
              state.searchFilter.apiQuery.filters.filter(
                (filter) => filter.field !== DBTilte[t as keyof typeof DBTilte]
              );
          }

          // Handle second field if provided
          if (action.payload.field2 && t === action.payload.field2) {
            state.searchFilter.columnSearch[t].value = "";
            state.searchFilter.columnSearch[t].isFiltered = false;

            // Remove corresponding filter from apiQuery.filters
            state.searchFilter.apiQuery.filters =
              state.searchFilter.apiQuery.filters.filter(
                (filter) => filter.field !== DBTilte[t as keyof typeof DBTilte]
              );
          }
        }
      }
    },
    UpdateDataAfterLogout: (state) => {
      state.searchFilter.apiQuery =
        notificationInitalState.searchFilter.apiQuery;
      state.searchFilter.columnSearch =
        notificationInitalState.searchFilter.columnSearch;
      state.searchFilter.tempColumnSearch =
        notificationInitalState.searchFilter.tempColumnSearch;
      state.searchFilter.globalSearch =
        notificationInitalState.searchFilter.globalSearch;
      state.searchFilter.globalSearchApiQuery =
        notificationInitalState.searchFilter.globalSearchApiQuery;
    },
    ResetColumnSearchFilter: (
      state,
      action: PayloadAction<{
        canClearAll: boolean;
        fieldClear: string;
        field2?: string;
      }>
    ) => {
      // Reset temp column search
      if (action.payload.canClearAll) {
        // Reset everything as before
        state.searchFilter.tempColumnSearch =
          notificationInitalState.searchFilter.tempColumnSearch;
      } else if (action.payload.fieldClear?.length > 0) {
        // Clear column search value and isFiltered
        let t: keyof ILocalFilterValue;
        for (t in state.searchFilter.tempColumnSearch) {
          if (t === action.payload.fieldClear) {
            state.searchFilter.tempColumnSearch[t].value = "";
            state.searchFilter.tempColumnSearch[t].isFiltered = false;
          }
          // Handle second field if provided
          if (action.payload.field2 && t === action.payload.field2) {
            state.searchFilter.tempColumnSearch[t].value = "";
            state.searchFilter.tempColumnSearch[t].isFiltered = false;
          }
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      //Create Notification
      .addCase(CreateNotification.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(CreateNotification.fulfilled, (state) => {
        state.api = getApiSuccessState();
      })
      .addCase(CreateNotification.rejected, (state) => {
        state.api = getApiFailState();
      })

      //Update Notification
      .addCase(UpdateNotification.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(UpdateNotification.fulfilled, (state) => {
        state.api = getApiSuccessState();
      })
      .addCase(UpdateNotification.rejected, (state) => {
        state.api = getApiFailState();
      })

      //Delete Notification
      .addCase(DeleteNotification.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(DeleteNotification.fulfilled, (state) => {
        state.api = getApiSuccessState();
      })
      .addCase(DeleteNotification.rejected, (state) => {
        state.api = getApiFailState();
      })

      //Get All Notification
      .addCase(GetAllNotification_M1.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(GetAllNotification_M1.fulfilled, (state, action) => {
        state.api = getApiSuccessState();
        state.notification_M1 = action.payload;
      })
      .addCase(GetAllNotification_M1.rejected, (state) => {
        state.api = getApiFailState();
      })

      /// Get All Notification M3
      .addCase(GetAllNotification_M3.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(
        GetAllNotification_M3.fulfilled,
        (state, action: PayloadAction<IFilterResponse>) => {
          state.api = getApiSuccessState();
          if (action.payload !== undefined){
            state.notification_M3 = action.payload?.data;
          if (action.payload.data !== undefined) {
            state.tableData = PrepareTableData(
              action.payload.data !== null ? action.payload.data : [],
              state.user,
              state.MultipleAssign,
              state.notificationFeatures
            );
          }
          state.searchFilter.apiQuery.page = action.payload.page;
          state.searchFilter.apiQuery.currentPageSize =
            action.payload.pageSize > 0 ? action.payload.pageSize : 10;
          state.searchFilter.apiQuery.sortField = action.payload.sortBy;
          state.totalCount = action.payload.totalCount;
          }
        }
      )
      .addCase(GetAllNotification_M3.rejected, (state) => {
        state.api = getApiFailState();
      })

      //Draft To Submit
      .addCase(DraftToSubmit.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(DraftToSubmit.fulfilled, (state) => {
        state.api = getApiSuccessState();
      })
      .addCase(DraftToSubmit.rejected, (state) => {
        state.api = getApiFailState();
      })

      //Add Or Update Assign
      .addCase(UpdateAssignToNotification.pending, (state) => {
        state.api = getApiLoadingState();
        state.IsAssigned = false;
      })
      .addCase(UpdateAssignToNotification.fulfilled, (state) => {
        state.api = getApiSuccessState();
      })
      .addCase(UpdateAssignToNotification.rejected, (state) => {
        state.api = getApiFailState();
      })

      //Publish Notification
      .addCase(PublishNotification.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(PublishNotification.fulfilled, (state) => {
        state.api = getApiSuccessState();
      })
      .addCase(PublishNotification.rejected, (state) => {
        state.api = getApiFailState();
      })

      //Recall Notification
      .addCase(RecallNotification.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(RecallNotification.fulfilled, (state) => {
        state.api = getApiSuccessState();
      })
      .addCase(RecallNotification.rejected, (state) => {
        state.api = getApiFailState();
      })

      //GetNotificationById
      .addCase(GetNotificationByID.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(
        GetNotificationByID.fulfilled,
        (state, action: PayloadAction<IPrepareIndividualData | null>) => {
          state.api = getApiSuccessState();
        }
      )
      .addCase(GetNotificationByID.rejected, (state) => {
        state.api = getApiFailState();
      })

      .addCase(GetPulishedNotification.pending, (state) => {
        state.api = getApiLoadingState();
      })
      .addCase(
        GetPulishedNotification.fulfilled,
        (state, action: PayloadAction<IUINotification_View_3[]>) => {
          state.api = getApiSuccessState();
          state.PublishedNotifications = action.payload;
        }
      )
      .addCase(GetPulishedNotification.rejected, (state) => {
        state.api = getApiFailState();
      });
  },
});
export const NotificationActions = notificationSlice.actions;
export default notificationSlice.reducer;

export const PrepareTableData = (
  notify: IUINotification_View_3[],
  user: ISSOUser | null,
  MultipleAssign: IMultiAssignData,
  notificationFeatures: INotificationFeatures
) => {
  let tableData = [] as INotificationTableList[];

  if (notify?.length > 0) {
    notify?.map((notification: IUINotification_View_3, index: number) => {
      let Data = {
        createdBy: { name: "", dateTime: "" },
        updatedBy: { name: "", dateTime: "" },
        rowSelection: { visibility: true },
      } as INotificationTableList;

      Data.nUniqueID = notification.nUniqueID;
      Data.status = notification.status;
      Data.title = notification.title;
      Data.description = notification.description;
      Data.level = notification.level;
      Data.expiryDate = notification.expiryDate;
      Data.effectiveDate = notification.effectiveDate;
      Data.target = notification.target;
      Data.notificationID = notification.notificationID;
      Data.assignedUser = notification.assignedUser;
      Data.assignedOn = notification.assignedOn;
      Data.category = notification.category;
      Data.createdBy.name = notification.createdBy;
      Data.createdBy.dateTime = notification.createdOn;
      Data.updatedBy.name = notification.updatedBy;
      Data.updatedBy.dateTime = notification.updatedOn;
      Data.status = notification.status;
      Data.attachments = notification.attachments;
      Data.publishStatus = notification.publishStatus;
      Data.publishedOn = notification.publishedOn;
      Data.zipFile = notification.zipFile;
      Data.actions = {
        assign: {
          applicable: ETableRowActionFieldApplicable.Blur,
          message: "Assign Notification",
        },
        delete: {
          applicable: ETableRowActionFieldApplicable.Show,
          message: "",
        },
        edit: {
          applicable: ETableRowActionFieldApplicable.Show,
          message: "",
        },
        recall: {
          applicable: ETableRowActionFieldApplicable.Blur,
          message: "",
        },
        view: {
          applicable: ETableRowActionFieldApplicable.Show,
          message: "view Notification",
        },
      };
      // Data.actions = NotificationTableActionHandler(
      //   Data,
      //   user,
      //   notificationFeatures
      // );
      Data.rowSelection.visibility = false;
      tableData.push(Data);
    });

    // Defining the row Action control
    NotificationTableActionHandler(tableData, user, notificationFeatures);
    //Defining the row selection visibility
    NotificationCheckboxHandlerNew(
      tableData,
      user,
      MultipleAssign,
      notificationFeatures
    );
  }

  return tableData;
};

export const prepareIndividualData = (
  id: string,
  tableData: INotificationTableList[]
) => {
  let notify = tableData.filter(
    (item: INotificationTableList) => item.notificationID === id
  )[0];
  let Data = {} as IPrepareIndividualData;
  if (notify) {
    Data.nUniqueID = notify.nUniqueID;
    Data.notificationID = notify.notificationID;
    Data.title = notify.title;
    Data.level = notify.level;
    Data.description = notify.description;
    Data.attachments = notify.attachments;
    Data.category = notify.category;
    Data.effectiveDate = notify.effectiveDate;
    Data.expiryDate = notify.expiryDate;
    Data.target = notify.target;
    Data.status = notify.status;
    Data.createdBy = {
      name: notify.createdBy.name,
      dateTime: notify.createdBy.dateTime,
    };
    Data.updatedBy = {
      name: notify.updatedBy.name,
      dateTime: notify.updatedBy.dateTime,
    };
    Data.zipFile = notify.zipFile;
    Data.publishedOn = notify.publishedOn;
    Data.assignedUser = notify.assignedUser;
    Data.publishStatus = notify.publishStatus;
    Data.publishedBy = notify.publishedBy;
  }
  return Data;
};
